import { render, staticRenderFns } from "./_List.vue?vue&type=template&id=531fbb87&"
import script from "./_List.vue?vue&type=script&lang=js&"
export * from "./_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports